import { useMemo, useState } from "react";
import { Mail, Send } from "lucide-react";

export default function ShareByEmail({ title, description, path, subject, body, testId }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const shareUrl = useMemo(() => {
    if (typeof window === "undefined") return path;
    return `${window.location.origin}${path}`;
  }, [path]);

  const sendLink = (event) => {
    event.preventDefault();
    if (!email) return;
    const emailBody = `${body}\n\n${shareUrl}`;
    window.location.href = `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`;
    setSent(true);
  };

  return (
    <form onSubmit={sendLink} className="border border-[#E2E8F0] bg-white p-5" data-testid={`${testId}-share-form`}>
      <div className="flex items-start gap-3">
        <span className="grid h-10 w-10 shrink-0 place-items-center bg-[#0066FF] text-white" data-testid={`${testId}-share-icon`}>
          <Mail className="h-5 w-5" />
        </span>
        <div>
          <h3 className="font-heading text-lg font-black text-[#0A2540]" data-testid={`${testId}-share-title`}>{title}</h3>
          <p className="mt-2 text-sm leading-6 text-[#475569]" data-testid={`${testId}-share-description`}>{description}</p>
        </div>
      </div>
      <div className="mt-5 grid gap-3 sm:grid-cols-[1fr_auto]">
        <input
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
          placeholder="Enter email address"
          className="min-h-11 border border-[#CBD5E1] bg-white px-3 text-sm text-[#0B1120] focus:outline-none focus:ring-2 focus:ring-[#0066FF]"
          data-testid={`${testId}-share-email-input`}
        />
        <button type="submit" className="inline-flex items-center justify-center gap-2 bg-[#0A2540] px-5 py-3 text-sm font-bold text-white hover:bg-[#051424]" data-testid={`${testId}-share-send-button`}>
          Send link <Send className="h-4 w-4" />
        </button>
      </div>
      <p className="mt-3 break-all text-xs font-semibold text-[#64748B]" data-testid={`${testId}-share-url-text`}>{shareUrl}</p>
      <p className="mt-2 text-xs font-semibold text-[#64748B]" data-testid={`${testId}-share-email-app-note`}>Send opens your email app with the link ready to share.</p>
      {sent && <p className="mt-3 text-xs font-bold text-emerald-700" data-testid={`${testId}-share-sent-text`}>Email draft opened with this link.</p>}
    </form>
  );
}